import { combineLatest, defer, Observable, of } from 'rxjs';
import { catchError, map, startWith, switchMap, tap } from 'rxjs/operators';

import { Injectable } from '@angular/core';

import { ItemMenu } from '../models/internal/item-menu-model';

import { PermissionBaseComponent } from '../../../abstracts/permission-base.component';

import { PermissionService } from '../../../services/common/permission.service';

import { PharmasyncService } from '../../pharma-sync/service/pharmasync.service';

import { PERMISSIONS_GROUPS } from '../../../constants/permission-group.constants';
import { CnpjService } from '../../../services/common/cnpj.service';
import { UserStore } from '../models/internal/user.store';
import { ManagerPermissionService } from '../../../../modules/gestao/core/services/manager-permission.service';

@Injectable({
  providedIn: 'root'
})
export class MenuService extends PermissionBaseComponent {

  private itemMenu: ItemMenu[] = [
    {
      title: `Home`,
      icon:
        ` <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
            </svg>
            `,
      link: '/home',
      permission$: of(true)
    },
    {
      title: 'Gestão da loja',
      icon:
        ` <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 3v11.25A2.25 2.25 0 0 0 6 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0 1 18 16.5h-2.25m-7.5 0h7.5m-7.5 0-1 3m8.5-3 1 3m0 0 .5 1.5m-.5-1.5h-9.5m0 0-.5 1.5m.75-9 3-3 2.148 2.148A12.061 12.061 0 0 1 16.5 7.605" />
            </svg>
            `,
      link: '',
      submenu: [
        {
          title: 'Análise de vendas', link: '', aitrusRedirect: 'sale-analysis',
          permission$: this.createPermission$(PERMISSIONS_GROUPS.dashboard),
          blockedReason$: this.missingDataCaptureBlockedReason$()
        },
        {
          title: 'Análise de mercado', link: '', aitrusRedirect: 'market-analysis',
          permission$: this.createPermission$(PERMISSIONS_GROUPS.dashboard),
          blockedReason$: this.missingDataCaptureBlockedReason$()
        },
        {
          title: 'Análise de PBM', link: '', aitrusRedirect: 'pbm-analysis',
          permission$: this.createPermission$(PERMISSIONS_GROUPS.dashboard),
          blockedReason$: this.missingDataCaptureBlockedReason$()
        },
      ],
    },
    {
      title: 'Análise de mix',
      icon:
        ` <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="m21 7.5-9-5.25L3 7.5m18 0-9 5.25m9-5.25v9l-9 5.25M3 7.5l9 5.25M3 7.5v9l9 5.25m0-9v9" />
          </svg>
            `,
      link: '',
      aitrusRedirect: 'product-assortment',
      permission$: this.createPermission$(PERMISSIONS_GROUPS.dashboard),
      blockedReason$: this.missingDataCaptureBlockedReason$()
    },
    {
      title: 'Compras',
      icon:
        `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
      <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 0 0-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 0 0-16.536-1.84M7.5 14.25 5.106 5.272M6 20.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm12.75 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z" />
      </svg>
      `,
      link: '',
      aitrusRedirect: 'offers',
      // Sem bloqueio por `has_data`: as ofertas não dependem da captação de dados da loja.
      permission$: this.createPermission$(PERMISSIONS_GROUPS.shopping)
    },
    {
      // TBD-4: a Precificação da Aitrus ainda não está pronta, então estes itens apontam
      // para as nossas rotas internas. Quando os slugs chegarem, troca-se `link` por
      // `aitrusRedirect`.
      title: 'Precificação',
      icon: ` <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
      <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 18.75a60.07 60.07 0 0 1 15.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 0 1 3 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 0 0-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 0 1-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 0 0 3 15h-.75M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm3 0h.008v.008H18V10.5Zm-12 0h.008v.008H6V10.5Z" />
      </svg>
      `,
      link: '',
      submenu: [
        {
          title: 'Consultar produtos', link: '/precificacao/consulta-produto',
          permission$: this.createPermission$(PERMISSIONS_GROUPS.precification)
        },
        {
          title: 'Grupo de precificação', link: '/precificacao',
          permission$: this.createPermission$(PERMISSIONS_GROUPS.precification)
        },
        {
          title: 'Provisionamento', link: '/precificacao/provisioning',
          permission$: this.createPermission$(PERMISSIONS_GROUPS.precification)
        },
        {
          title: 'Rentabilidade de vendas', link: '/precificacao/purchase-analysis',
          permission$: this.createPermission$(PERMISSIONS_GROUPS.precification)
        },
      ],
    },
    {
      title: 'Marketing',
      // Arte de 18 unidades contra as 19,5 dos demais: o <g> amplia em torno do centro e
      // divide a espessura pelo mesmo fator, como já se fazia no ícone de Tutoriais.
      icon:
        `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
      <g transform="translate(12 12) scale(1.0833) translate(-12 -12)" stroke-width="1.385">
      <path stroke-linecap="round" stroke-linejoin="round" d="M10.34 15.84c-.688-.06-1.386-.09-2.09-.09H7.5a4.5 4.5 0 1 1 0-9h.75c.704 0 1.402-.03 2.09-.09m0 9.18c.253.962.584 1.892.985 2.783.247.55.06 1.21-.463 1.511l-.657.38c-.551.318-1.26.117-1.527-.461a20.845 20.845 0 0 1-1.44-4.282m3.102.069a18.03 18.03 0 0 1-.59-4.59c0-1.586.205-3.124.59-4.59m0 9.18a23.848 23.848 0 0 1 8.835 2.535M10.34 6.66a23.847 23.847 0 0 0 8.835-2.535m0 0A23.74 23.74 0 0 0 18.795 3m.38 1.125a23.91 23.91 0 0 1 1.014 5.395m-1.014 8.855c-.118.38-.245.754-.38 1.125m.38-1.125a23.91 23.91 0 0 0 1.014-5.395m0-3.46c.495.413.811 1.035.811 1.73 0 .695-.316 1.317-.811 1.73m0-3.46a24.347 24.347 0 0 1 0 3.46" />
      </g>
      </svg>
      `,
      link: '',
      submenu: [
        {
          title: 'Campanhas', link: '/file-manager', permission$: of(this.permissionService.isInGroup(PERMISSIONS_GROUPS.fileManager))
        },
        {
          title: 'Materiais institucionais', link: '/file-manager/farmacia', permission$: of(this.permissionService.isInGroup(PERMISSIONS_GROUPS.fileManager))
        },
      ],
    },
    {
      title: 'Mix de novas lojas',
      icon:
        ` <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 21v-7.5a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75V21m-4.5 0H2.36m11.14 0H18m0 0h3.64m-1.39 0V9.349M3.75 21V9.349m0 0a3.001 3.001 0 0 0 3.75-.615A2.993 2.993 0 0 0 9.75 9.75c.896 0 1.7-.393 2.25-1.016a2.993 2.993 0 0 0 2.25 1.016c.896 0 1.7-.393 2.25-1.016a3.001 3.001 0 0 0 3.75.615m-16.5 0a3.004 3.004 0 0 1-.621-4.72l1.189-1.19A1.5 1.5 0 0 1 5.378 3h13.243a1.5 1.5 0 0 1 1.06.44l1.19 1.189a3 3 0 0 1-.621 4.72M6.75 18h3.75a.75.75 0 0 0 .75-.75V13.5a.75.75 0 0 0-.75-.75H6.75a.75.75 0 0 0-.75.75v3.75c0 .414.336.75.75.75Z" />
            </svg>
            `,
      link: '/dashboard/sugestao-mix-lojas-novas',
      permission$: of(this.permissionService.isInGroup(PERMISSIONS_GROUPS.dashboard))
    },
    {
      title: 'Potencial comercial',
      // Mapa, e não alfinete: a ferramenta analisa a região em volta do ponto, não marca
      // um endereço. Arte de 18 unidades, compensada como a de Marketing.
      icon:
        ` <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
      <g transform="translate(12 12) scale(1.0833) translate(-12 -12)" stroke-width="1.385">
      <path stroke-linecap="round" stroke-linejoin="round" d="M9 6.75V15m6-6v8.25m.503 3.498 4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 0 0-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0Z" />
            </g>
            </svg>
            `,
      link: '/potencial-ponto-comercial',
      permission$: this.createPermission$(PERMISSIONS_GROUPS.potencialDoPontoComercial)
    },
    // {
    //   // TBD-5: falta decidir se Supply é rota interna ou destino Aitrus, e qual permissão
    //   // o rege. A de shopping é palpite para não deixá-lo aberto a todo mundo.
    //   title: 'Supply',
    //   icon:
    //     ` <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
    //         <g transform="translate(12 12) scale(1.0833) translate(-12 -12)" stroke-width="1.385">
    //         <path stroke-linecap="round" stroke-linejoin="round" d="m21 7.5-9-5.25L3 7.5m18 0-9 5.25m9-5.25v9l-9 5.25M3 7.5l9 5.25M3 7.5v9l9 5.25m0-9v9" />
    //         </g>
    //         </svg>
    //         `,
    //   link: '',
    //   permission$: this.createPermission$(PERMISSIONS_GROUPS.shopping)
    // },
    {
      title: 'Agendar reunião',
      icon:
        `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" />
              </svg>
              `,
      link: '/agendamento',
      permission$: this.createPermission$([this.permissions.licenciado, this.permissions.interno])
    },
    {
      title: 'Administrativo',
      icon:
        `
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
              <path stroke-linecap="round" stroke-linejoin="round" d="m20.25 7.5-.625 10.632a2.25 2.25 0 0 1-2.247 2.118H6.622a2.25 2.25 0 0 1-2.247-2.118L3.75 7.5M10 11.25h4M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z" />
               </svg>
              `,
      link: '',
      submenu: [
        {
          title: 'Documentos', link: '/documentos', permission$: of(true)
        },
        {
          // O estado deste item não sai daqui: ItemMenuComponent o casa pela rota, porque
          // instalar o PharmaSync não destrava extrato — só ser licenciado ou interno.
          title: 'Extrato financeiro', link: '/extrato-financeiro', permission$: of(this.permissionService.isInGroup(PERMISSIONS_GROUPS.billing))
        },
      ],
    },
    {
      // Área de gestão (ex-PharmaManager). `hideWhenNoAccess` em todos os níveis: para
      // quem é de fora a área não existe, e não um item desabilitado com tooltip.
      //
      // A engrenagem do heroicons ocupa 17,19 das 24 unidades contra as 19,5 dos demais;
      // o <g> amplia em torno do centro e divide a espessura pelo mesmo fator, como já se
      // fazia em Marketing e Tutoriais.
      title: 'Gestão',
      icon:
        `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
        <g transform="translate(12 12) scale(1.1335) translate(-12 -12)" stroke-width="1.3233">
        <path stroke-linecap="round" stroke-linejoin="round" d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.26 1.431l-1.003.827c-.293.241-.438.613-.43.992a7.723 7.723 0 0 1 0 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.217-.456c-.355-.133-.750-.072-1.076.124a6.47 6.47 0 0 1-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.297-2.247a1.125 1.125 0 0 1 .26-1.431l1.004-.827c.292-.24.437-.613.43-.991a6.932 6.932 0 0 1 0-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.077-.124.072-.044.146-.086.22-.128.331-.183.581-.495.644-.869l.213-1.28Z" />
        <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
        </g>
        </svg>
        `,
      link: '',
      hideWhenNoAccess: true,
      permission$: this.gestaoAccess$(),
      submenu: [
        {
          title: 'Dashboards',
          link: '/gestao/dashboards',
          hideWhenNoAccess: true,
          permission$: this.gestaoPageAccess$('dashboards')
        },
        {
          title: 'Usuários',
          link: '/gestao/usuarios',
          hideWhenNoAccess: true,
          permission$: this.gestaoPageAccess$('list-users')
        },
        {
          title: 'Cadastro de clientes',
          link: '/gestao/cadastro/lojas',
          hideWhenNoAccess: true,
          permission$: this.gestaoPageAccess$('store-registration')
        },
        {
          title: 'Condição comercial',
          link: '/gestao/cadastro/condicao-comercial',
          hideWhenNoAccess: true,
          permission$: this.gestaoPageAccess$('commercial-condition')
        },
        {
          title: 'Grupos econômicos',
          link: '/gestao/grupos-economicos',
          hideWhenNoAccess: true,
          permission$: this.gestaoPageAccess$('list-economic-group')
        },
        {
          title: 'Análise de mercado',
          link: '/gestao/analise-de-mercado',
          hideWhenNoAccess: true,
          permission$: this.gestaoPageAccess$('pharmaceutical-market-analysis')
        },
        {
          title: 'Contratos',
          link: '/gestao/contratos',
          hideWhenNoAccess: true,
          permission$: this.gestaoPageAccess$('list-contracts')
        },
        {
          title: 'Ativar precificação',
          link: '/gestao/ativar-precificacao',
          hideWhenNoAccess: true,
          permission$: this.gestaoPageAccess$('ativar-precificacao')
        },
        {
          title: 'Produtos',
          link: '/gestao/produtos',
          hideWhenNoAccess: true,
          permission$: this.gestaoPageAccess$('product')
        },
        {
          title: 'Gerência de credenciais',
          link: '/gestao/gerencia-credenciais',
          hideWhenNoAccess: true,
          permission$: this.gestaoPageAccess$('gerencia-credenciais')
        },
        {
          title: 'Gerador de URL',
          link: '/gestao/gerador-url',
          hideWhenNoAccess: true,
          permission$: this.gestaoPageAccess$('gerador-url')
        },
        {
          title: 'Jornal de Ofertas',
          link: '/jornal-ofertas',
          hideWhenNoAccess: true,
          permission$: of(this.permissionService.isInGroup([this.permissions.interno]))
        },
      ],
    }
  ]

  constructor(
    override permissionService: PermissionService,
    private pharmaSyncService: PharmasyncService,
    private cnpjService: CnpjService,
    private userStore: UserStore,
    private managerPermissionService: ManagerPermissionService
  ) {
    super(permissionService)
    this.pharmaSyncService.pharmasyncStatus$
      .pipe(
        tap()
      )
      .subscribe();
    this.decorateMenuWithVisibility();

  }

  /**
   * Acesso à área de gestão, pelo mesmo caminho do `permissionGuard` da rota `/gestao`.
   * Reativo de propósito: `of(isInGroup(...))` congelaria um snapshot tirado antes de
   * os grupos do token chegarem, e o item nunca apareceria.
   */
  private gestaoAccess$(): Observable<boolean> {
    return this.permissionService.loadUserGroups().pipe(
      map(() => this.permissionService.isInGroup(PERMISSIONS_GROUPS.gestao))
    );
  }

  /**
   * Visibilidade de uma tela de gestão: precisa do grupo (mesma porta do `permissionGuard`
   * de `/gestao`) E da permissão de leitura da tela (mesmo `permissionTarget` do
   * `managerPagePermissionGuard`). Sem o grupo nem busca permissões.
   */
  private gestaoPageAccess$(target: string): Observable<boolean> {
    return this.gestaoAccess$().pipe(
      switchMap(inGroup => inGroup
        ? this.managerPermissionService.hasPagePermissionAsync(target, 'read')
        : of(false))
    );
  }

  private currentUserEmail(): string {
    return (this.userStore.user().email || '').toLowerCase();
  }

  /**
   * `has_data` do CNPJ selecionado; null enquanto a lista não chega, se o CNPJ não
   * estiver nela ou se a busca falhar. O defer adia o acesso ao CnpjService até alguém
   * assinar.
   */
  private selectedCnpjHasData$(): Observable<boolean | null> {
    return defer(() => combineLatest([this.cnpjService.getCnpjs(), this.cnpjService.selectedCnpj$])).pipe(
      map(([resp, cnpj]) => {
        const found = Array.isArray(resp?.data) ? resp.data.find(item => item.cnpj === cnpj) : undefined;
        return typeof found?.has_data === 'boolean' ? found.has_data : null;
      }),
      // O CnpjService encerra o stream com erro se a lista falhar; sem isto o async do
      // menu estouraria. Sem a informação, o item não é bloqueado.
      catchError(() => of(null))
    );
  }

  /**
   * Bloqueio dos itens que dependem da captação de dados da loja: com `has_data`
   * false, o item não abre e o clique avisa o motivo.
   */
  private missingDataCaptureBlockedReason$(): Observable<string | null> {
    return this.selectedCnpjHasData$().pipe(
      // `=== false`, e não `!hasData`: null (lista carregando ou CNPJ fora dela) não bloqueia.
      map(hasData => hasData === false
        ? 'Essa loja ainda não possui usuário de captação cadastrado.\nPara acessar esta tela, procure seu consultor para regularizar a captação de dados da loja.'
        : null)
    );
  }

  /** Observable que emite true se a conta atingir o mínimo de CNPJs */
  private hasMinCnpjs$(min: number): Observable<boolean> {
    return this.cnpjService.getCnpjs().pipe(
      map(resp => Array.isArray(resp?.data) ? resp.data.length >= min : false),
      startWith(false) // até carregar tratamos como não visível
    );
  }

  private combineVisibility$(base$: Observable<boolean | null> | undefined, allowedEmails?: string[], minCnpjs?: number, subsType?: string): Observable<boolean> {
    const basePerm$ = base$ ?? of(true);

    const emailOk$ = allowedEmails?.length
      ? of(this.currentUserEmail()).pipe(map(e => allowedEmails.map(x => x.toLowerCase()).includes(e)))
      : of(true);

    const cnpjOk$ = typeof minCnpjs === 'number'
      ? this.hasMinCnpjs$(minCnpjs)
      : of(true);

    const subscriptionOk$ = this.subscriptionVisibility$(subsType);

    return combineLatest([basePerm$, emailOk$, cnpjOk$, subscriptionOk$]).pipe(
      map(([perm, emailOk, cnpjOk, subscriptionOk]) => !!perm && emailOk && cnpjOk && subscriptionOk)
    );
  }

  private subscriptionVisibility$(subscriptionType?: string): Observable<boolean> {
    if (!subscriptionType) {
      return of(true);
    }

    const allowedPlans = subscriptionType
      .split(/[|,]/)
      .map(plan => plan.trim().toLowerCase())
      .filter(plan => !!plan);

    if (!allowedPlans.length) {
      return of(true);
    }

    const checkObservables: Observable<boolean>[] = allowedPlans.map(plan => {
      switch (plan) {
        case 'freemium':
          return this.permissionService.isUserFreemium();
        case 'otimiza':
          return this.permissionService.isUserOtimiza();
        case 'interno':
          return this.permissionService.isUserInterno();
        case 'licenciado':
          return this.permissionService.isUserLicenciado();
        default:
          return of(false);
      }
    });

    return combineLatest(checkObservables).pipe(
      map(results => results.some(Boolean))
    );
  }

  private decorateMenuWithVisibility(): void {
    this.itemMenu.forEach(item => {
      // item de 1º nível
      item.permission$ = this.combineVisibility$(item.permission$, item.allowedEmails, item.minCnpjs, item.subscriptionType);

      // submenus
      if (Array.isArray(item.submenu)) {
        item.submenu.forEach(sub => {
          sub.permission$ = this.combineVisibility$(sub.permission$, sub.allowedEmails, sub.minCnpjs, sub.subscriptionType);
        });
      }
    });
  }

  public createPermission$(groups: string[]): Observable<boolean | null> {
    return combineLatest([
      of(this.permissionService.isInGroup(groups)),
      this.pharmaSyncService.pharmasyncStatus$.pipe(startWith(false))
    ]).pipe(
      map(([isInGroup, hasSync]) => {
        const result = isInGroup || hasSync;
        return result;
      })
    );
  }

  getItemMenu(): ItemMenu[] {
    return this.itemMenu;
  }

}
